import { fetchChild, fetchChildren } from "@/api/profile";

export default {
  namespaced: true,
  state: {
    children: [],
    childInfo: [],
    hasError: {},
  },

  mutations: {
    SET_CHILDREN_DATA(state, payload) {
      state.children = payload;
    },
    SET_CHILD_INFO(state, payload) {
      state.childInfo = payload;
    },
    SET_ERROR(state, status) {
      state.hasError = status;
    },
  },

  actions: {
    async loadChildren({ commit } = {}) {
      try {
        const response = await fetchChildren();
        commit("SET_CHILDREN_DATA", response.data);
      } catch (error) {
        commit("SET_ERROR", error);
        throw error;
      }
    },

    async loadChild({ commit }, query) {
      try {
        const response = await fetchChild(query);
        commit("SET_CHILD_INFO", response.data);
        return response.data;
      } catch (error) {
        commit("SET_ERROR", error);
        throw error;
      }
    },
  },

  getters: {
    children: (state) => state.children,
    childInfo: (state) => state.childInfo,
  },
};
